import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c30db6ea&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c30db6ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30db6ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c30db6ea')) {
      api.createRecord('c30db6ea', component.options)
    } else {
      api.reload('c30db6ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c30db6ea&scoped=true&", function () {
      api.rerender('c30db6ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mp/wxautoreply/index.vue"
export default component.exports